import { bind } from "@react-rxjs/core";
import { injectable } from "inversify";
import { CSSProperties } from "react";
import { BehaviorSubject } from "rxjs";

@injectable()
export default class ConfigRepo {
    isInitialized = false;
    private stylesSubject: BehaviorSubject<Map<string, CSSProperties>> = new BehaviorSubject(new Map());
    public useBuildStyles = bind(this.stylesSubject, new Map())[0];

    async getStyles() {
        try {
            const style = await (await fetch("/resources/styles.json")).json();
            const stylesMap = new Map()
            for (const key in style) {
                stylesMap.set(key, style[key]);
            }
            console.log(style, stylesMap)
            this.stylesSubject.next(stylesMap);
        } catch (err) {
            console.log(err);
        }
    }

    async getConfigs() {
        if (!this.isInitialized) {
            await this.getStyles();
            this.isInitialized = true;
        }
    }
}